module.exports = __webpack_public_path__ + "static/media/05.b04a40a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/singapore/05.jpg
// module id = 518
// module chunks = 0